// 中文语言包
export default {
  // 通用文本
  common: {
    loading: '加载中...',
    error: '出错了',
    success: '成功',
    confirm: '确认',
    cancel: '取消',
    save: '保存',
    delete: '删除',
    edit: '编辑',
    back: '返回',
    next: '下一步',
    previous: '上一步',
    submit: '提交',
    reset: '重置',
    search: '搜索',
    filter: '筛选',
    sort: '排序',
    refresh: '刷新',
    close: '关闭',
    open: '打开',
    yes: '是',
    no: '否',
    currentLanguage: '当前语言',
    userAvatar: '用户头像',
    icon: '图标',
    arrow: '箭头',
    impact: '影响'
  },

  // 页面标题
  titles: {
    home: '健康报告',
    overview: '全部数据概览',
    details: '详情',
    nutrition: '营养素详情',
    nutritions: '营养素综合',
    tissue: '身体内脏',
    assess: '调理状态评估',
    scheme: '调理方案',
    recuperate: '调理详情',
    condition: '调理方案详情',
    compare: '健康评估比对',
    microelement: '微量元素',
    aiQuestionnaire: 'AI问卷',
    reportNumber: '报告编号',
    healthReport: '健康报告',
    detectionReport: '检测报告',
    // Overview 页面特有标题
    bodyHealthInfo: '身体健康信息',
    comprehensiveDataReport: '综合数据评估报告',
    dataDisclaimer: '数据为营养活力定性指标，不作为就诊建议亦不构成病理诊断',
    constitutionAssessment: '体质状态评估',
    constitutionAssessmentSubtitle: '（综合当前营养状态和基础体质，供参考）',
    nutritionAssessment: '营养素评估',
    constitutionEvaluation: '体质评估',
    bodyAssessment: '身体评估',
    nutritionDataReport: '营养素数据报表',
    bodyOrgansDataReport: '身体内脏数据报表',
    bodyComprehensiveDataReport: '身体综合数据报表'
  },

  // 健康相关
  health: {
    // 健康指标
    indicators: {
      liver: '肝功能',
      kidney: '肾功能',
      heart: '心功能',
      lung: '肺功能',
      spleen: '脾功能',
      stomach: '胃功能',
      intestine: '肠功能',
      brain: '脑功能',
      bone: '骨骼',
      muscle: '肌肉',
      blood: '血液',
      immune: '免疫系统',
      endocrine: '内分泌',
      nervous: '神经系统',
      reproductive: '生殖系统',
      urinary: '泌尿系统'
    },
    
    // 健康状态
    status: {
      normal: '正常',
      abnormal: '异常',
      excellent: '优异',
      good: '良好',
      average: '达标',
      fair: '一般',
      poor: '较差',
      critical: '严重',
      improving: '改善中',
      stable: '稳定',
      declining: '下降',
      // 器官状态相关
      healthy: '健康',
      subHealth: '亚健康',
      warning: '预警',
      risk: '风险',
      attention: '注意',
      maintain: '保持',
      strengthen: '加强',
      improve: '改善'
    }
  },

  // 营养相关
  nutrition: {
    // 营养素名称
    items: {
      vitaminA: '维生素A',
      vitaminB1: '维生素B1',
      vitaminB2: '维生素B2',
      vitaminB6: '维生素B6',
      vitaminB12: '维生素B12',
      vitaminC: '维生素C',
      vitaminD: '维生素D',
      vitaminE: '维生素E',
      vitaminK: '维生素K',
      folicAcid: '叶酸',
      niacin: '烟酸',
      biotin: '生物素',
      calcium: '钙',
      iron: '铁',
      zinc: '锌',
      magnesium: '镁',
      phosphorus: '磷',
      potassium: '钾',
      sodium: '钠',
      selenium: '硒',
      copper: '铜',
      manganese: '锰',
      iodine: '碘',
      chromium: '铬',
      molybdenum: '钼'
    },
    
    // 营养页面相关
    sections: {
      dynamicDataTracking: '动态数据跟踪',
      bodyAssociatedItems: '影响身体关联项',
      dietaryRecommendations: '饮食建议',
      exerciseRecommendations: '运动建议',
      lifestyleRecommendations: '起居建议',
      projectDescription: '项目说明',
      foodSources: '食物来源'
    },
    
    // 营养建议相关
    recommendations: {
      dietary: '饮食建议',
      exercise: '运动建议',
      lifestyle: '起居建议',
      dailyRoutine: '起居建议'
    },
    
    // 营养建议通用术语
    terms: {
      increase: '增加',
      decrease: '减少',
      maintain: '保持',
      avoid: '避免',
      consume: '摄入',
      supplement: '补充',
      balance: '平衡',
      moderate: '适量',
      daily: '每日',
      weekly: '每周',
      morning: '早晨',
      afternoon: '下午',
      evening: '晚上',
      beforeMeals: '餐前',
      afterMeals: '餐后',
      fruits: '水果',
      vegetables: '蔬菜',
      proteins: '蛋白质',
      carbohydrates: '碳水化合物',
      fats: '脂肪',
      fiber: '纤维',
      water: '水分',
      exercise: '运动',
      rest: '休息',
      sleep: '睡眠',
      stress: '压力',
      relaxation: '放松'
    }
  },

  // 图表相关
  charts: {
    // 图表元素
    elements: {
      initialValue: '初值',
      finalValue: '终值',
      currentValue: '当前值',
      targetValue: '目标值',
      averageValue: '平均值',
      maxValue: '最大值',
      minValue: '最小值',
      trend: '趋势',
      comparison: '对比',
      percentage: '百分比',
      score: '评分',
      level: '等级',
      range: '范围',
      unit: '单位',
      dynamicDataTracking: '动态数据跟踪',
      nutritionAssociation: '营养关联',
      organAssociation: '内脏关联',
      mainAssociationRatio: '主要关联比例',
      
      // 图例相关
      actualValue: '实测数值',
      standardValue: '标准数值',
      normalValue: '正常数值',
      excellentIndicator: '优良指标',
      needAttention: '需要关注',
      excellent: '优秀',
      
      // CircleProgress组件相关
      exceedUsers: '超越全国用户',
      bodyStatus: '身体状况',
      
      // GaugeCard组件相关
      nutritionBalanceIndicator: '营养均衡指标',
      nutritionStatus: '营养状况',
      imbalance: '失衡',
      insufficient: '不足',
      moderate: '适中',
      good: '良好',
      attention: '关注',
      
      // WaterfallCard组件相关
      nutritionVitalityTip: '营养活力提示',
      warningTip: '预警提示',
      qualifiedItems: '合格项目',
      abnormalValue: '异常数值',
      
      // 提示框相关
      standard: '标准',
      measured: '实测',
      value: '数值',
      status: '状态'
    }
  },

  // 数据概览相关
  dataOverview: {
    detectionItem: '检测项目',
    initialValue: '初值',
    finalValue: '终值',
    averageValue: '均值',
    loadingText: '加载中...',
    vitamins: '维生素',
    microelements: '微量元素',
    minerals: '矿物质',
    warningCount: '预警项目',
    qualifiedCount: '合格项目',
    bodyDynamicChart: '身体综合检测动态图',
    organDynamicChart: '身体内脏检测动态图',
    nutritionDynamicChart: '营养素检测动态图',
    averageStatusChart: '平均值状态图',
    bodyAverageStatusChart: '身体综合平均值状态图',
    organAverageStatusChart: '身体内脏平均值状态图',
    nutritionAverageStatusChart: '营养素平均值状态图',
    comprehensiveDataTable: '综合数据报告表',
    organDataTable: '身体内脏数据报告表',
    nutritionDataTable: '营养素数据报告表',
    // Nutritions 页面专用
    nutritionStatusChart: '营养素状态图',
    detailedDataReportTable: '详细数据报告表',
    nutritionConditioningAdvice: '营养素调理建议'
  },

  // 操作按钮
  actions: {
    viewDetails: '查看详情',
    viewMore: '查看更多',
    startQuestionnaire: '开始问卷',
    downloadReport: '下载报告',
    shareReport: '分享报告',
    printReport: '打印报告',
    exportData: '导出数据',
    compareReports: '对比报告',
    scheduleAppointment: '预约检测',
    contactDoctor: '联系医生',
    viewHistory: '查看历史',
    updateProfile: '更新资料',
    viewHealthInfo: '查看身体健康信息',
    customSolution: '一键定制解决方案',
    viewFullHealthInfo: '查看全面健康信息',
    exerciseRecommendation: '运动建议',
    lifestyleRecommendation: '起居建议',
    bodyAssociatedItems: '影响身体关联项',
    nutritionAssociatedItems: '营养素关联项',
    view: '查看',
    expandMore: '展开更多',
    collapse: '收起'
  },

  // 调理方案相关
  conditioning: {
    scheme: '调理方案',
    schemeList: '调理方案列表',
    conditioningPlan: '调理方案',
    conditioningDetails: '调理详情',
    conditioningAdvice: '调理建议',
    conditioningRecommendation: '调理推荐',
    viewScheme: '查看方案',
    viewConditioning: '查看调理',
    planDescription: '方案描述',
    planDetails: '方案详情',
    implementationPlan: '实施方案',
    conditioningMethod: '调理方法',
    expectedEffect: '预期效果',
    attentionMatters: '注意事项',
    usageDuration: '使用周期',
    dosageInstructions: '用量说明',
    // Recuperate页面专用
    specialConditioningProject: '特色调理项目',
    conditioningExplanation: '调理说明',
    conditioningCycle: '调理周期',
    bodyMainConditioningItems: '身体主要调理项',
    nutritionMainConditioningItems: '营养素主要调理项',
    improvementProjectComparison: '提高项目对比图',
    detailedDataReportTable: '详细数据报告表',
    detectionItem: '检测项目',
    averageValue: '平均值',
    lastDetection: '上次检测',
    currentDetection: '本次检测',
    specialAttention: '特别注意'
  },

  // 评估页面相关
  assessment: {
    title: '调理状态评估',
    improvementProjectChart: '提高项目对比图',
    awaitImprovementChart: '有待提高项目比对图',
    dynamicComparisonChart: '动态比对图',
    interpretationTitle: '解读说明',
    lastDetection: '上次检测',
    currentDetection: '本次检测',
    lastInitialValue: '上次初值',
    lastFinalValue: '上次终值',
    currentInitialValue: '本次初值',
    currentFinalValue: '本次终值'
  },

  // 对比页面相关
  comparison: {
    title: '健康评估比对',
    before: '前',
    after: '后',
    improvementProjectChart: '提高项目对比图',
    awaitImprovementChart: '有待提高项目比对图',
    dynamicComparisonChart: '动态比对图',
    comparisonDataReportTable: '比对数据报告表',
    interpretationTitle: '解读说明',
    previousDetection: '前次检测',
    laterDetection: '后次检测',
    previousInitialValue: '前次初值',
    previousFinalValue: '前次终值',
    laterInitialValue: '后次初值',
    laterFinalValue: '后次终值',
    detectionItem: '检测项目',
    comparisonResult: '比对结果',
    improved: '已提升',
    needsImprovement: '待提升'
  },

  // 器官页面相关
  tissue: {
    projectDescription: '项目说明',
    dynamicTrackingMode: '动态跟踪模式',
    averageStatusChart: '平均值状态图',
    bodyAssociatedItems: '影响身体关联项',
    dietaryRecommendations: '饮食建议',
    exerciseRecommendations: '运动建议',
    lifestyleRecommendations: '起居建议',
    interpretationGuide: '解读说明'
  },

  // 用户信息相关
  user: {
    height: '身高',
    weight: '体重',
    age: '岁',
    bmi: 'BMI',
    bodyFatRatio: '体脂率',
    obesityIndex: '肥胖指数',
    heightUnit: 'cm',
    weightUnit: 'kg',
    bodyFatUnit: '%',
    defaultName: '苏大力'
  },

  // 健康状态相关
  healthStatus: {
    lifeFeature: '超越全国用户',
    bodyCondition: '身体状况',
    healthy: '健康',
    good: '良好',
    abnormal: '异常',
    nutritionRisk: '营养失衡风险',
    healthRisk: '健康风险提示（脏器指标）',
    noAbnormalRisk: '未见异常风险',
    noAbnormalRiskFound: '未见异常风险'
  },

  // 弹窗相关
  dialogs: {
    interpretTitle: '解读说明',
    lifeFeatureTitle: '超越全国用户',
    lifeFeatureDesc: '表示您的健康状况超越了全国多少百分比的用户。该数值越高，表示您的身体状况相对更好。',
    bodyConditionTitle: '身体状况',
    bodyConditionDesc: '是指全身各个内脏组织器官的综合评估结果。',
    bodyConditionHealthy: '健康：身体状况处于最佳状态，各项功能运转良好。',
    bodyConditionGood: '良好：身体状况正常，但仍有提升空间。',
    bodyConditionAbnormal: '异常：身体状况异常，可能存在不适或功能失调。',
    riskTitle: '风险说明',
    riskDesc: '营养均衡指标从0到1，数值越高表示营养状态越好。失衡（低于0.3）、正常（0.3-0.7）、优异（高于0.7）。'
  },

  // 检测要求和注意事项
  requirements: {
    title: '监测要求和注意事项',
    item1: '1、本设备是一种配合临床报告和个人主诉并进行实质性探测的个性化超高灵敏动态跟踪系统。监测前填写的主诉问答与临床验血报告，会与测试数据产生个性化关联而进行动态跟踪若不填写将会失去动态跟踪功能，因此用户必须认真填写!',
    item2: '2、报告中的风险提示项是根据本次监测数据及健康评估的即时结果，按照人体各系统与相关内脏器官之间的关联关系，通过人工智能及大数据分析提示有可能发生某种疾病的趋势，并非代表全部的疾病风险，也并非指目前一定是正在发病的状态;由于设备采用了极高灵敏度的探测和预警功能，因此所及的相关提示，有可能是在临床诊断还未提及的潜在疾病或风险，应针对个人的健康状态，在不同时段进行多次监测，并配合相关临床和专业医生应用多次测试数据的规律做进一步的解析。',
    item3: '3、报告中所提供的监测数据反映的是人体实时体质的即时数据，在不同时段的监测数据均会发生变化，这是因为不同时段的睡眠、运动、精神、环境、药物使用等各种因素的影响所致;因此建议用户按照个人健康状况，分隔每日长期进行多次监测，以获取更多数据找出体质变化规律，使其实现更加精准。',
    item4: '4、AI 小助手提供的所有信息和建议均基于您的检测数据和公开健康知识库生成，仅作为健康参考，不可作为诊断、治疗的直接依据。如有任何身体不适，请及时咨询专业医生。'
  },

  // AI解读相关
  aiInterpret: {
    title: 'AI解读整体健康状况',
    keyResults: '关键监测结果',
    affectedConstitution: '可能受影响的身体体质',
    importantTip: '重要提示：多项营养缺乏',
    multipleDeficiency: '发现多项营养素严重缺乏，可能影响重要器官功能',
    noKeyResults: '暂无关键监测结果数据',
    analyzing: '正在进行深度分析，请稍等片刻',
    generating: 'AI正在生成总结中...',
    currentLevel: '当前水平仅为',
    normalRange: '正常值'
  },

  // 营养活力卡片相关
  nutritionVitality: {
    title: '营养活力提示',
    needAttention: '需要关注',
    excellentIndicator: '优良指标'
  },

  // 饮食建议相关
  dietAdvice: {
    title: 'AI调养建议',
    recentDietAdvice: '近期饮食建议',
    notRecommendedFoods: '种不推荐食材',
    recommendedFoods: '种推荐食材',
    reduceIntake: '建议减少摄入',
    recommendedSupplement: '推荐补充食物',
    noNotRecommendedFoods: '未见不推荐食材',
    lifestyleImprovement: '生活方式改善建议',
    dietAdviceDialog: '每日进行食物适应性测试，按照每日建议饮食定时定量，全面均衡，严禁食用不耐受食物。'
  },

  // AI助手相关
  aiAssistant: {
    title: 'AI助手',
    disclaimer: 'AI建议仅供参考，不做医疗诊断依据，请咨询专业医生。',
    welcomeMessage: '嗨，我是盈养AI小助手！\n可以和我聊聊您对监测报告的疑问，将为您解答各种问题！',
    inputPlaceholder: '向盈养AI小助手提问吧~',
    holdToSpeak: '按住说话',
    speakingTimeTooShort: '说话时间太短',
    waitForAIComplete: '请等待AI解读完成后再使用聊天功能',
    responseNotComplete: '回答未完成，稍等一下～',
    noMoreHistory: '没有更多历史消息了',
    loadingMore: '加载更多...',
    recordingCancelled: '录音已取消',
    recordingFailed: '录音失败，请重试',
    voiceRecognitionFailed: '语音识别失败，请重试',
    noSpeechDetected: '未识别到说话内容，请重试',
    releaseToCancel: '松开取消',
    releaseToSend: '松手发送 上移取消',
    errorResponse: '很抱歉未能回答（网络或问题限制）。建议：\n 1. 稍后重试 \n2. 检查网络 \n3. 换种提问方式 \n',
    recordingStartFailed: '录音启动失败，请检查权限：',
    microphonePermissionRequired: '需要录音权限才能使用语音功能',
    miniProgramInitializing: '小程序环境初始化中，请稍后重试',
    wechatInitializing: '微信功能初始化中，请稍后重试',
    wechatSDKInitFailed: '微信SDK初始化失败，请刷新页面重试',
    wechatVersionNotSupported: '当前微信版本不支持录音功能',
    grantMicrophonePermission: '请授予录音权限',
    recordingProcessFailed: '录音处理失败',
    recordingStopFailed: '录音停止失败，请重试',
    recordingNotSupported: '当前环境不支持录音功能',
    recordingDataError: '录音数据异常，请重试',
    stopRecordingIn: '{seconds} s 后停止语音'
  }
}